import React from "react";
import { Button } from "@mui/material";
import { FieldValues, useForm } from "react-hook-form";

import FormField from "./FormField";
import { FormFieldType } from "../../types/form/form-types";

interface DocumentManagementFormProps {
  defaultValues: FieldValues;
  formFields: FormFieldType[];
  // Parent component defines type of form_values by fields & defaultValues
  handleFormSubmit: (form_values: any) => void;
  className?: string;
  loading?: boolean;
  confirmButtonText?: string;
  disableSubmit?: boolean;
}

const FormGenerator: React.FC<DocumentManagementFormProps> = (props) => {
  const {
    defaultValues,
    formFields,
    handleFormSubmit,
    className = "",
    loading = false,
    confirmButtonText = "Submit",
    disableSubmit = false,
  } = props;

  const form = useForm({
    defaultValues,
  });

  const { handleSubmit, reset } = form;

  function onSubmit(data: FieldValues) {
    if (!loading) {
      handleFormSubmit(data);
    }
  }

  function handleReset() {
    reset();
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} onReset={handleReset} className={className}>
      {formFields.map((field) => (
        <FormField key={field.id} field={field} form={form} />
      ))}
      {/* Modal Action Buttons */}
      <div className="submit-buttons flex justify-end items-center w-full gap-4">
        <Button variant="outlined" type="reset">
          Reset
        </Button>
        <Button variant="contained" type="submit" disabled={disableSubmit}>
          {loading ? (
            <div className="lds-ring lds-ring--white">
              <div></div>
            </div>
          ) : (
            confirmButtonText
          )}
        </Button>
      </div>
    </form>
  );
};

export default FormGenerator;
